import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, closeCollapsible, translate, formatDateToPtbr, getUserNameToName } from '../../../../utils/util';
import * as containerAction from '../../../../actions/containerAction';
import ContainerService from '../../../../services/ContainerService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import { ENUMS } from '../../../../utils/constants';

const CoverageCalculationList = (props) => {
    const [coveragePaged, setCoveragePaged] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [filter, setFilter] = useState({ internal: false });

    useEffect(() => {
        if (props.filters) {
            setFilter(props.filters);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setCoveragePaged(props.coveragePaged?.items || []);
        // eslint-disable-next-line
    }, [props?.coveragePaged?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getCoveragePaged({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }


    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };


    const exportCsv = () => {
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'partNumberCode',
                header: "Desenho",
                align: 'left',
                sortable: false
            },
            {
                field: 'partNumberDescription',
                header: 'Descrição',
                align: 'left',
                sortable: true
            },
            {
                field: 'approverCode',
                header: 'Cód Apro.',
                align: 'left',
                sortable: true
            },
            {
                field: 'approverName',
                header: 'Nome Apro.',
                align: 'left',
                sortable: true
            },
            {
                field: 'stockHermes',
                header: 'Hermes',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockHermes < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockHermes}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockSens',
                header: 'BDL',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockSens < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockSens}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockCbj0',
                header: 'CBJ0',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockCbj0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockCbj0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockTotalContainer',
                header: 'Qtd. TC Total',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockTotalContainer < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockTotalContainer}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockInPort',
                header: 'Qtd. TC Porto',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockInPort < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockInPort}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockInPlant',
                header: 'Qtd. TC Planta',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockInPlant < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockInPlant}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'automaticLowQuantity',
                header: 'Qtd. Baixa Aut.',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.automaticLowQuantity < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.automaticLowQuantity}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceStartOfDay0',
                header: 'Dif. J0 ID',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceStartOfDay0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceStartOfDay0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceStartOfDay0',
                header: 'Dif. J0 Man',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceStartOfDay0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceStartOfDay0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockInPlant',
                header: 'Qtd. TC D-',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockInPlant < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockInPlant}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockTotalD0',
                header: 'Qtd. TC J0',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockTotalD0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockTotalD0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceEndOfDay0',
                header: 'Dif J0 FD',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceEndOfDay0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceEndOfDay0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceEndOfDay0',
                header: 'Dif J0 Man',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceEndOfDay0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceEndOfDay0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'stockCbj1',
                header: 'CBJ1',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.stockCbj1 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.stockCbj1}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceStartOfDay1',
                header: 'Dif. J1 ID',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceStartOfDay1 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceStartOfDay1}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'differenceStartOfDay1',
                header: 'Dif. J1 Man',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.differenceStartOfDay1 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.differenceStartOfDay1}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'pieceHourD0',
                header: 'Pça/Hora J0',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.pieceHourD0 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.pieceHourD0}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'pieceHourD1',
                header: 'Pça/Hora J1',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.pieceHourD1 < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.pieceHourD1}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'totalCoverage',
                header: 'Cobertura',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.totalCoverage < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.totalCoverage}
                        </span>
                    </div>

                },
                sortable: true
            },
            {
                field: 'openingHour',
                header: 'Hora de Abertura',
                align: 'right',
                body: (rowData) => {
                    return <div>
                        <span
                            style={{
                                color:
                                    rowData.openingHour < 0
                                        ? 'red'
                                        : 'inherit'
                            }}
                        >
                            {rowData.openingHour}
                        </span>
                    </div>

                },
                sortable: true
            },
        ];
        return cols;
    };





    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Cálculo Cobertura de Peças" }} />
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>

                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="partNumberCode"
                                                name='partNumberCode'
                                                label="Desenho"
                                                type="text"
                                                defaultValue={filter?.partNumberCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>

                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <Table
                    totalPages={props.coveragePaged?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={coveragePaged}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        coveragePaged: state.containerReducer.coveragePaged,
        filters: state.containerReducer.printFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCoveragePaged: (filter) => {
            dispatch(ContainerService.getCoveragePaged(filter));
        },
        setContainerFilters: (filters) => {
            dispatch(containerAction.setContainerFilters(filters));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoverageCalculationList));
